import { ThemeContext, Typography } from "@vitality-ds/components";
import { Link as GatsbyLink } from "gatsby";
import React, { useContext } from "react";

import vitalityLogo from "../../../../../../images/vitality.svg";
import DocsBox from "../../../../../DocsBox";
import { Image, LogoFlex } from "./styled";

function Logo() {
  const { theme } = useContext(ThemeContext);
  const isDarkMode = theme === "dark";
  return (
    <LogoFlex>
      <GatsbyLink to="/">
        <Image
          css={isDarkMode && { filter: "grayscale() invert(100%)" }}
          src={vitalityLogo}
        />
        <DocsBox
          className="designSystemText"
          css={{
            "@media (max-width: 960px) ": { display: "none" },
          }}
        >
          <Typography htmlTag="span" color="lowContrast">
            Design System
          </Typography>
        </DocsBox>
      </GatsbyLink>
    </LogoFlex>
  );
}

export default Logo;
